
export interface FeeConfig {
	identifier: number;
	id: string;
	flatFee?: number;
	expediteFee?: number;
	department?: string;
	fund?: string;
	ali?: string;
	program?: string;
	revenueSourceCode?: string;
	reporting?: string;
	accountDescription?: string;
	effectiveFromDate: Date;
	effectiveToDate?: Date;
	feeMatrices?: FeeMatrix[];
	feeTypes?: FeeType[];
	legalReference: string;
	assessedInRICS?: boolean;
	displayName?: string;
}

export class UpdatedFeeRequest implements FeeConfig {
	identifier: number;
	id: string;
	flatFee?: number;
	expediteFee?: number;
	department?: string;
	fund?: string;
	ali?: string;
	program?: string;
	revenueSourceCode?: string;
	reporting?: string;
	accountDescription?: string;
	effectiveFromDate: Date;
	effectiveToDate?: Date;
	feeMatrices?: FeeMatrix[];
	feeTypes?: FeeType[];
	assessedInRICS?: boolean;
	displayName?: string;
	legalReference: string;
	isDirty: boolean = false;

	constructor(conf: FeeConfig) {
		this.identifier = conf.identifier;
		this.id = conf.id;
		this.flatFee = conf.flatFee;
		this.expediteFee = conf.expediteFee;
		this.department = conf.department;
		this.fund = conf.fund;
		this.ali = conf.ali;
		this.program = conf.program;
		this.revenueSourceCode = conf.revenueSourceCode;
		this.reporting = conf.reporting;
		this.accountDescription = conf.accountDescription;
		this.effectiveFromDate = conf.effectiveFromDate;
		this.effectiveToDate = conf.effectiveToDate;
		this.feeMatrices = conf.feeMatrices;
		this.feeTypes = conf.feeTypes;
		this.assessedInRICS = conf.assessedInRICS;
		this.displayName = conf.displayName;
		this.legalReference = conf.legalReference;
	}
}


export interface FeeMatrix {
	id: number;
	configId: number;
	feeCode?: string;
	amount: number;
}

export interface FeeType {
	id: number;
	configId: number;
	feeType?: string;
}